//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'V',
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  }
};